import { call } from 'redux-saga/effects';
import { makeRestartable } from 'utils/redux/saga';
import threads from './threads';
import messages from './messages';

const rootSagas = [threads, messages].map(makeRestartable);

function* root() {
  yield rootSagas.map(saga => call(saga));
}

export default root;



// WEBPACK FOOTER //
// ./src/modules/messaging/sagas/index.js